export function staffServices(services, staffId) {
  // Include services that are set to "All Staffs"
  const allStaffServices = services.filter(s => s.staffs.length === 0)
  const specificStaffServices = services.filter(s => s.staffs.length > 0)

  return [
    ...allStaffServices,
    ...specificStaffServices.filter(service => {
      return (
        service.staffs.find(staff => staff.id === staffId) ||
        service.additionalStaff.find(staff => staff.id === staffId)
      )
    })
  ]
}

export const serviceStaffs = ({ service, business, includeAdditionalStaff=false }) => {
  if(!service || service.staffs.length === 0) {
    return business.staffs.filter(s => s.enabled && s.user)
  }

  let serviceStaffsIds = [
    ...service.staffs.filter(s => s.enabled && s.user).map(s => s.id),
    ...service.additionalStaff.filter(s => s.enabled && s.user).map(s => s.id),
  ]

  if (includeAdditionalStaff) {
    serviceStaffsIds = [
      ...serviceStaffsIds,
      ...service.additionalStaff.filter(s => s.enabled && s.user).map(s => s.id),
    ]
  }

  return business.staffs.filter(s => serviceStaffsIds.indexOf(s.id) !== -1)
}
